
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Globe, Phone, Mail, Facebook, Instagram } from "lucide-react";
import { Business } from "@/types";
import SocialMediaLinks from "./SocialMediaLinks";

interface ContactCardProps {
  business: Business;
}

const ContactCard: React.FC<ContactCardProps> = ({ business }) => {
  const hasSocialMedia = business.facebook || business.instagram || business.tiktok;

  return (
    <Card className="mb-6">
      <CardContent className="p-6">
        <h3 className="text-lg font-medium mb-4">Contact Information</h3>
        
        {business.website && (
          <div className="flex items-center mb-3">
            <Globe className="h-5 w-5 mr-3 text-eco-500" />
            <a
              href={business.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-eco-500 hover:underline"
            >
              Visit Website
            </a>
          </div>
        )}
        
        {business.phone && (
          <div className="flex items-center mb-3">
            <Phone className="h-5 w-5 mr-3 text-eco-500" />
            <a href={`tel:${business.phone}`} className="text-eco-500 hover:underline">
              {business.phone}
            </a>
          </div>
        )}
        
        {business.email && (
          <div className="flex items-center mb-3">
            <Mail className="h-5 w-5 mr-3 text-eco-500" />
            <a href={`mailto:${business.email}`} className="text-eco-500 hover:underline">
              {business.email}
            </a>
          </div>
        )}

        {hasSocialMedia && (
          <SocialMediaLinks 
            facebook={business.facebook}
            instagram={business.instagram}
            tiktok={business.tiktok}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default ContactCard;
